import React, { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { Form } from './FirstForm';
import { AppContext } from '../App';
import { industries } from '../Content';
import { getResults } from './RiskScores';
import { colors } from '../styles/utilities/settings';

const recaptchaRef = React.createRef();

const FinalForm = () => {
  const [openDrawer, setOpenDrawer] = useState(false);

  return (
    <AppContext.Consumer>
      {value => (
        <div>
          <h2>Take Action</h2>
          <Form blue>
            <p>Request a free assessment in and around your location to determine your pest risk and contributing factors.</p>
            <form
              action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"
              method="POST"
            >
              <ReCAPTCHA
                ref={recaptchaRef}
                size="invisible"
                sitekey="6LdB0dUUAAAAAGY08FDDqfHwWCQoymR1MIUpsokG"
              />
              <input type="hidden" name="oid" value="00D20000000Bt5d" />
              <input type="hidden" name="retURL" value="https://www.ecolab.com/pages/pest-risk-thank-you" />
              <fieldset>
                <div className="fieldset">
                  <div className="field half">
                    <label htmlFor="first_name">First Name</label>
                    <input
                      id="first_name"
                      maxLength="40"
                      name="first_name"
                      size="20"
                      type="text"
                      required
                    />
                  </div>
                  <div className="field half">
                    <label htmlFor="last_name">Last Name</label>
                    <input
                      id="last_name"
                      maxLength="80"
                      name="last_name"
                      size="20"
                      type="text"
                      required
                    />
                  </div>
                  <div className="field">
                    <label htmlFor="company">Company</label>
                    <input
                      id="company"
                      maxLength="40"
                      name="company"
                      size="20"
                      type="text"
                      required
                    />
                  </div>
                  <div className="field">
                    <label htmlFor="industry">Market Segment:</label>
                    <div
                      className="app-form-input"
                      onKeyPress={(e) => {
                        e.key === 'Enter' && setOpenDrawer(!openDrawer);
                      }}
                      onClick={() => setOpenDrawer(!openDrawer)}
                    >
                      <input
                        required
                        name="industry"
                        readOnly
                        type="text"
                        value={(value.userIndustry && value.userIndustry.label) ||
                        'Select Industry'}
                      />
                      <span className="arrow">
                        <span />
                        <span />
                      </span>
                      {openDrawer !== false && (
                      <ul>
                        {industries.map(ind => (
                          <li key={Math.random()}>
                            <a
                              href="/"
                              onClick={(e) => {
                                e.preventDefault();
                                setOpenDrawer(!openDrawer);
                                value.setUserIndustry(ind);
                                getResults(value.userZip, ind, value.setResults);
                              }}
                            >
                              {ind.label}
                            </a>
                          </li>
                        ))}
                      </ul>
                      )}
                    </div>
                    <select value={value.userIndustry.code} style={{ display: 'none' }} id="00N0J00000A65YA" name="00N0J00000A65YA" title="Market Segment">
                      <option value="">--None--</option>
                      <option value="EDUC & GOVMNT">Buildings, Facilities, Schools & Government</option>
                      <option value="FOOD PROCESS">Food & Beverage Manufacturing</option>
                      <option value="FOOD RETAIL">Food Retail Service</option>
                      <option value="FOOD SERVICE">Foodservice, Restaurant</option>
                      <option value="HLTHCARE">Healthcare</option>
                      <option value="HOSPITALITY">Hospitality</option>
                      <option value="MANUFACTURING">Manufacturing</option>
                      <option value="QSR">Quick Service Restaurant</option>
                      <option value="RETAIL NON FOOD">Retail</option>
                    </select>
                  </div>
                  <div className="field">
                    <label htmlFor="street">Street</label>
                    <textarea name="street" />
                  </div>
                  <div className="field half">
                    <label htmlFor="city">City</label>
                    <input
                      id="city"
                      maxLength="40"
                      name="city"
                      size="20"
                      type="text"
                    />
                  </div>
                  <div className="field fourth">
                    <label htmlFor="state">State</label>
                    <input
                      id="state"
                      maxLength="20"
                      name="state"
                      size="20"
                      type="text"
                    />
                  </div>
                  <div className="field fourth">
                    <label htmlFor="zip">Zip Code</label>
                    <input
                      onChange={e => {
                        value.setUserZip(e.target.value);
                        getResults(e.target.value, value.userIndustry, value.setResults);
                      }}
                      id="zip"
                      maxLength="20"
                      name="zip"
                      size="20"
                      type="text"
                      value={value.userZip}
                      required
                    />
                  </div>
                  <div className="field">
                    <label htmlFor="email">Email</label>
                    <input
                      value={value.userEmail}
                      id="email"
                      maxLength="80"
                      name="email"
                      size="20"
                      type="text"
                      required
                    />
                  </div>
                  <div className="field">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      id="phone"
                      maxLength="40"
                      name="phone"
                      size="20"
                      type="text"
                      required
                    />
                  </div>
                </div>
              </fieldset>
              <p>What is your biggest pest concern?</p>
              <div className="app-form-checkbox">
                <input
                  type="checkbox"
                  name="00N0J00000AMsKW"
                  id="Ants"
                  value="Ants"
                />
                <label htmlFor="Ants">Ants</label>
              </div>
              <div className="app-form-checkbox">
                <input
                  type="checkbox"
                  name="00N0J00000AMsKW"
                  id="Bed Bugs"
                  value="Bed Bugs"
                />
                <label htmlFor="Bed Bugs">Bed Bugs</label>
              </div>
              <div className="app-form-checkbox">
                <input
                  type="checkbox"
                  name="00N0J00000AMsKW"
                  id="Birds"
                  value="Birds"
                />
                <label htmlFor="Birds">Birds</label>
              </div>
              <div className="app-form-checkbox">
                <input
                  type="checkbox"
                  name="00N0J00000AMsKW"
                  id="Cockroaches"
                  value="Cockroaches"
                />
                <label htmlFor="Cockroaches">Cockroaches</label>
              </div>
              <div className="app-form-checkbox">
                <input
                  type="checkbox"
                  name="00N0J00000AMsKW"
                  id="Large Flies"
                  value="Large Flies"
                />
                <label htmlFor="Large Flies">Large Flies</label>
              </div>
              <div className="app-form-checkbox">
                <input
                  type="checkbox"
                  name="00N0J00000AMsKW"
                  id="Mosquitoes"
                  value="Mosquitoes"
                />
                <label htmlFor="Mosquitoes">Mosquitoes</label>
              </div>
              <div className="app-form-checkbox">
                <input
                  type="checkbox"
                  name="00N0J00000AMsKW"
                  id="Occasional Invaders"
                  value="Occasional Invaders"
                />
                <label htmlFor="Occasional Invaders">Occasional Invaders</label>
              </div>
              <div className="app-form-checkbox">
                <input
                  type="checkbox"
                  name="00N0J00000AMsKW"
                  id="Rodents"
                  value="Rodents"
                />
                <label htmlFor="Rodents">Rodents</label>
              </div>
              <div className="app-form-checkbox">
                <input
                  type="checkbox"
                  name="00N0J00000AMsKW"
                  id="Small Flies"
                  value="Small Flies"
                />
                <label htmlFor="Small Flies">Small Flies</label>
              </div>
              <div className="app-form-checkbox">
                <input
                  type="checkbox"
                  name="00N0J00000AMsKW"
                  id="Stored Product Pests"
                  value="Stored Product Pests"
                />
                <label htmlFor="Stored Product Pests">Stored Product Pests</label>
              </div>
              <div className="app-form-checkbox">
                <input
                  type="checkbox"
                  name="00N0J00000AMsKW"
                  id="Termites"
                  value="Termites"
                />
                <label htmlFor="Termites">Termites</label>
              </div>
              <div className="app-form-checkbox">
                <input
                  type="checkbox"
                  name="00N0J00000AMsKW"
                  id="Other/General Pest Control"
                  value="Other/General Pest Control"
                />
                <label htmlFor="Other/General Pest Control">
                Other/General Pest Control
                </label>
              </div>
              <input
                type="hidden"
                name="recordType"
                id="recordType"
                value="01220000000R0vj"
              />
              <input
                type="hidden"
                name="country"
                id="country"
                value="United States"
              />
              <input type="hidden" name="currency" id="currency" value="USD" />
              <input
                type="hidden"
                name="lead_source"
                id="lead_source"
                value="Campaign"
              />
              <input type="hidden" name="rating" id="rating" value="Chaud" />
              <input
                type="hidden"
                name="Campaign_ID"
                id="Campaign_ID"
                value="7010J000001Oak7"
              />
              <input
                type="hidden"
                name="member_status"
                id="member_status"
                value="Responded"
              />

              <div className="app-form-copy" style={{ margin: '10px 0 0 0' }}>
                <div className="app-form-checkbox" style={{ width: '100%', marginBottom: '20px', lineHeight: '1.5' }}>
                  <input id="00N0J00000A65Y0" name="00N0J00000A65Y0" type="checkbox" value="1" />
                  <label htmlFor="00N0J00000A65Y0">
                Do you agree to receive promotional offers, updates and other information from Ecolab?
                  </label>
                </div>
                <p>By checking this box, you are agreeing that Ecolab may contact you via email with promotional offers, updates, and other information. If you wish to continue your customer relationship without receiving marketing communication, you may submit your information without checking this box.</p>
                <p>
                  Data Privacy Concerns? See our
                  {' '}
                  <a
                    href="https://www.ecolab.com/privacy-policy"
                    style={{
                      color: colors.darkerGray,
                      textDecoration: 'underline'
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                </p>
              </div>
              <input type="hidden" name="recordType" id="recordType" defaultValue="01220000000R0vj" />
              <input type="hidden" name="country" id="country" defaultValue="United States" />
              <input type="hidden" name="currency" id="currency" defaultValue="USD" />
              <input type="hidden" name="lead_source" id="lead_source" defaultValue="Campaign" />
              <input type="hidden" name="rating" id="rating" defaultValue="Chaud" />
              <input type="hidden" name="Campaign_ID" id="Campaign_ID" defaultValue="7010J000001Oak7" />
              <input type="hidden" name="member_status" id="member_status" defaultValue="Responded" />
              <div className="app-form-submit">
                <input type="submit" name="submit" />
              </div>
            </form>
          </Form>
        </div>
      )}
    </AppContext.Consumer>
  );
};

export default FinalForm;
